import styled from 'styled-components'

export const Row = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`

export const ChartContainer = styled.div`
  flex: 3;
  display: flex;
  flex-direction: column;
`

export const LegendContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-right: 25px;
  gap: 5px;
`

export const LegendItem = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  color: #222222;
  gap: 7px;
`

export const LegendLabel = styled.p`
  font-size: 14px;
  line-height: 14px;
  margin: 0px;
`

export const ColorBox = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${props => props.color};
  flex-shrink: 0;
  margin-top: 1px;
`
